/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description ageTextFunction
 */

/**
 * get a string describing how old something is
 *
 * @param {number} age how old is it
 * @param {string} zero what does it look like if it's 0 old (e.g. 'Just now')
 * @param {string} one what if it's 1 old (e.g. '1 minute ago')
 * @param {string} n what if it's multiple old (e.g. ' minutes ago')
 * @param {string} nX what if it's really old (e.g. 'over an hour ago')
 * @param {number} x define really old (e.g. 60)
 */
const ageTextFunction = <T extends string, N extends string>(
  age: number,
  zero: T,
  one: T,
  n: N,
  nX: T,
  x: number
) => {
  if (x && nX && age >= x) {
    return nX
  } else if (age > 1) {
    return `${age}${n}` as const
  } else if (age === 1) {
    return one
  }
  return zero
}

export default ageTextFunction
